import { createRef, useEffect } from 'react';

export const useListKeys = (focusFirstElement: boolean, selector?: string) => {
    const listRef = createRef<HTMLUListElement>();

    useEffect(() => {
        if (selector) {
            const element = listRef.current as HTMLElement;
            let items = Array.prototype.slice.call(listRef?.current?.querySelectorAll(selector)) as HTMLElement[];

            const handleKeyboardEvent = (ev: KeyboardEvent) => {
                let currentIndex = items.findIndex((e) => e === ev.target);
                items = Array.prototype.slice.call(element.querySelectorAll(selector)) as HTMLElement[];

                if (ev.code === 'ArrowDown' || ev.code === 'ArrowUp' || ev.code === 'Home' || ev.code === 'End') {
                    ev.preventDefault();
                    ev.stopPropagation();
                }

                if (ev.code === 'ArrowDown') {
                    currentIndex++;
                    items[currentIndex]?.focus();
                } else if (ev.code === 'ArrowUp') {
                    currentIndex--;
                    items[currentIndex]?.focus();
                } else if (ev.code === 'Home') {
                    items[0]?.focus();
                } else if (ev.code === 'End') {
                    items[items.length - 1]?.focus();
                }
            };

            if (focusFirstElement) {
                const elements = element.querySelectorAll(selector);
                (elements[0] as HTMLElement)?.focus();
            }

            element.addEventListener('keydown', handleKeyboardEvent);

            return () => element.removeEventListener('keydown', handleKeyboardEvent);
        }
    }, [selector]);

    return {
        listRef,
    };
};
